import React from 'react';
import styles from './FaqAnswerImg.module.scss';
import { useDesktopQuery } from '../../../../../Hooks';

export interface FaqAnswerImgProps {
  srcMobile: string;
  srcDesktop: string;
}

export const FaqAnswerImg = ({
  srcMobile,
  srcDesktop
}: FaqAnswerImgProps): React.ReactElement<FaqAnswerImgProps> => {
  const isDesktop: boolean = useDesktopQuery();
  const src: string = isDesktop ? srcDesktop : srcMobile;

  return <img className={styles.faqAnswerImg} src={src} alt="" />;
};
